import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=2cee61d1&scoped=true&lang=pug&"
import script from "./Download.vue?vue&type=script&lang=js&"
export * from "./Download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cee61d1",
  null
  
)

export default component.exports